import React from 'react';

import { Box, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

import { ActionItemKeys } from '@uplift/api';
import { settingsRoute } from '@uplift/constants';
import { trackToDoCTA, useL10n } from '@uplift/hooks';
import { UserRole } from '@uplift/types';
import { Alert, Link } from '@uplift/ui-v2';

export const MissingNameBanner: React.FC = () => {
  const l10n = useL10n();
  const { classes } = useStyles();
  const copy = l10n.dashboard.actionItems.missingName.banner;

  return (
    <Alert severity="warning" classes={{ root: classes.root, message: classes.message }} data-testid="missing-name-banner">
      <Box className={classes.content}>
        <Box>
          <Typography variant="body1" fontWeight={600}>{copy.title}</Typography>
          <Typography variant="body2">{copy.text}</Typography>
        </Box>
        <Link
          to={settingsRoute.createLink(null, { edit: 'name' })}
          className={classes.link}
          onClick={() => trackToDoCTA({
            toDoType: ActionItemKeys.CLIENT_MISSING_NAME,
            userType: UserRole.patient
          })}
        >
          {copy.actionText}
        </Link>
      </Box>
    </Alert>
  );
};

const useStyles = makeStyles()(theme => ({
  root: {
    backgroundColor: theme.palette.warning.background,
    padding: theme.spacing(2, 3),
  },
  message: {
    flex: 1,
    padding: 0,
  },
  content: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    flexWrap: 'wrap',
  },
  link: {
    fontWeight: 600,
    color: theme.palette.warning.darkText,
    whiteSpace: 'nowrap',
    '&:visited': {
      color: theme.palette.warning.darkText,
    },
    '&:hover': {
      color: theme.palette.warning.dark,
    },
  },
}));
